<template>
  <div class="order-insurance">
    <div class="header">
      <div class="header-left">
        <div class="header-title">旅游保险</div>
        <div class="tips">
          <img
            class="icon"
            src="https://o.666visa.cn/static/ssqpeer/order/insurance-icon.png"
            alt=""
          />
          <div class="tips-text">安心出行，生效前可退改</div>
        </div>
      </div>
      <div class="header-right" @click="buyInsurance">
        立即购买
      </div>
    </div>

    <div class="insuance-body">
      <div class="product-info-box">
        <div class="product-info">
          <plan-item
            v-for="(plan, index) in order.product_insurance_new"
            :key="index"
            :plan="plan"
            :active="selectedPlanIndex === index"
            @click.native="selectPlan(index)"
          >
          </plan-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlanItem from './order-insurance-plan.vue';

export default {
  components: {
    PlanItem,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    insuranceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      selectedPlanIndex: 0,
      selectCurrentPlan: {},
    };
  },
  watch: {
    'order.product_insurance_new': {
      handler(val) {
        this.selectCurrentPlan = Object.assign({}, val[0]);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initInsurance();
  },
  methods: {
    initInsurance() {
      this.selectCurrentPlan.checked = true;
      const defaultPlanId = this.order.product_insurance_new.findIndex(item => item.is_default);
      this.selectedPlanIndex = defaultPlanId;
      Object.assign(this.selectCurrentPlan, this.order.product_insurance_new[defaultPlanId]);
    },
    // 把选中的保险传给外部 做订单提交校验
    selectPlan(idx) {
      this.selectedPlanIndex = idx;
      this.selectCurrentPlan = Object.assign(
        {},
        {
          ...this.selectCurrentPlanDefault,
          ...this.order.product_insurance_new[idx],
        },
      );
      this.$emit('update-insurance-info', this.selectCurrentPlan);
    },
    buyInsurance() {
      if (this.selectCurrentPlan.insurance_id) {
        this.$router.push({
          name: 'insuranceDetail',
          params: { id: this.selectCurrentPlan.insurance_product_id },
          query: { caseCode: this.selectCurrentPlan.case_code },
        });
      } else {
        this.$router.push({
          name: 'insurances',
          query: { from: 'order_after_buy' },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.order-insurance {
  margin-top: 20px;
  background: #fff;
  line-height: 1;
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    .header-left {
      display: flex;
      .checkbox {
        margin-right: 12px;
      }
      .header-title {
        font-size: 20px;
        font-weight: 600;
        color: #2f333d;
        margin-right: 16px;
      }
      .tips {
        display: flex;
        align-items: center;
        padding: 0 18px 0 26px;
        background: linear-gradient(
          270deg,
          rgba(255, 128, 51, 0) 0%,
          rgba(255, 128, 51, 0.1) 100%
        );
        position: relative;
        height: 24px;
        .icon {
          width: 20px;
          height: 19px;
          position: absolute;
          left: -4px;
          top: 50%;
          transform: translateY(-50%);
        }
        .tips-text {
          font-size: 14px;
          color: #ff8033;
          font-weight: 600;
        }
      }
    }
    .header-right {
      width: 76px;
      height: 36px;
      line-height: 36px;
      background: #599fff;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
    }
  }
  .insuance-body {
    padding: 10px 24px 24px ;
    .product-info-box {
      background: #fafbfc;
      position: relative;
      padding: 32px 20px 20px;
      border-radius: 2px;
      .product-info {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 16px;
        padding-bottom: 20px;

        &:hover {
          cursor: pointer;
        }
        .selected {
          background: rgba(255, 223, 191, 0.2);
          border-color: #ff5900;
          .selected-icon {
            display: block;
          }
        }
      }
      .insurance-form {
        border-top: 1px dashed #dee2e6;
        padding: 20px 0 0;
        display: flex;
        flex-wrap: wrap;
        .form-item {
          width: 340px;
          margin-right: 30px;
          display: flex;
          flex-direction: column;
          .item-label {
            color: #2f333d;
            font-size: 16px;
            margin-bottom: 8px;
          }
          .item-content {
            color: #2f333d;
            font-size: 14px;
            .insurance-day-box {
              border: 1px solid #dee2e6;
              border-radius: 2px;
              /deep/ .el-select {
                height: 38px;
                width: 100%;
                .el-input {
                  .el-input__icon {
                    width: 24px;
                    transform: translateY(-50%) rotateZ(180deg) scale(0.7);
                    transform-origin: center center;
                    right: 4px;
                    color: #91999f;
                    &.is-reverse {
                      transform: translateY(-50%) scale(0.7);
                    }
                  }
                  .el-input__inner {
                    border: none;
                    height: 38px;
                    border-radius: 2px;
                    padding-right: 24px;
                    color: #2f333d;
                    font-size: 14px;
                  }
                }
              }
              .over-day {
                /deep/ .el-select {
                  .el-input {
                    .el-input__inner {
                      border-top: 1px solid #dee2e6;
                    }
                  }
                }
              }
            }
            /deep/ .el-date-editor {
              width: 100%;
              .el-icon-date {
              }
              .el-input__inner {
                height: 40px;
                border-radius: 2px;
                padding-right: 24px;
                color: #2f333d;
                font-size: 14px;
              }
            }

            .end-day {
              color: #2f333d;
              font-size: 12px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-user-insurance-card.vue